if (!customElements.get('bf-deal-navigation')) {
  class BFDealNavigation extends HTMLElement {
    connectedCallback() {
      this.lifecycle = new AbortController();
      const { signal } = this.lifecycle;
      this.nav = this.querySelector('nav');
      this.links = [...this.querySelectorAll('a[href^="#"]')];
      this.targets = new Set();
      document.documentElement.classList.add('bf-deal-navigation-active');
      const schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => this.update());
      };
      window.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', () => { this.centerPending = true; schedule(); }, { passive: true, signal });
      document.addEventListener('shopify:section:load', schedule, { signal });
      document.addEventListener('shopify:section:unload', schedule, { signal });
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        if (link.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }
        this.lockedLink = link;
        this.centerPending = true;
        this.select(link);
        clearTimeout(this.lockTimer);
        this.lockTimer = setTimeout(() => { this.lockedLink = null; this.update(); }, 1000);
        // Leave scrolling to the same theme anchor handler used by FAQ links.
        history.replaceState(null, '', link.hash);
      }, { signal });
      this.update();
      document.fonts?.ready.then(() => { if (!signal.aborted) { this.centerPending = true; this.update(); } });
    }

    select(active) {
      this.links.forEach((link) => {
        link.classList.toggle('is-active', link === active);
        if (link === active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      if (active && (active !== this.activeLink || this.centerPending) && this.nav.scrollWidth > this.nav.clientWidth) {
        const bar = this.nav.getBoundingClientRect();
        const item = active.getBoundingClientRect();
        if (window.matchMedia('(max-width: 700px)').matches) {
          const left = this.nav.scrollLeft + item.left + item.width / 2 - bar.left - bar.width / 2;
          const target = Math.max(0, Math.min(this.nav.scrollWidth - this.nav.clientWidth, left));
          if (Math.abs(this.nav.scrollLeft - target) > 1) this.nav.scrollTo({ left: target, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        } else {
          const delta = item.left < bar.left ? item.left - bar.left : item.right > bar.right ? item.right - bar.right : 0;
          if (delta) this.nav.scrollBy({ left: delta, behavior: 'instant' });
        }
      }
      this.centerPending = false;
      this.activeLink = active;
    }

    update() {
      this.frame = 0;
      this.nav.classList.toggle('is-visible', window.scrollY > 35);
      const cutoff = this.nav.getBoundingClientRect().bottom + 150;
      let active;
      this.links.forEach((link) => {
        const target = document.getElementById(link.hash.slice(1));
        if (target) { target.classList.add('bf-deal-anchor'); this.targets.add(target); }
        const available = target && target.getClientRects().length > 0;
        if (available) link.removeAttribute('aria-disabled');
        else link.setAttribute('aria-disabled', 'true');
        if (available && (!active || target.getBoundingClientRect().top <= cutoff)) active = link;
      });
      this.select(this.lockedLink || active);
    }

    disconnectedCallback() {
      this.lifecycle.abort();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.lockTimer);
      this.targets.forEach((target) => target.classList.remove('bf-deal-anchor'));
      if (!document.querySelector('bf-deal-navigation')) document.documentElement.classList.remove('bf-deal-navigation-active');
    }
  }
  customElements.define('bf-deal-navigation', BFDealNavigation);
}
